import { render, staticRenderFns } from "./CommitImage.vue?vue&type=template&id=dc646646"
import script from "./CommitImage.vue?vue&type=script&lang=js"
export * from "./CommitImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports